export default {
  // Navbar
  nav_brand: 'CSSBuy Spreadsheet',
  nav_home: 'Início',
  nav_articles: 'Artigos',
  nav_categories: 'Categorias',
  nav_shopping_guide: 'Guia de Compras',
  nav_language: 'Idioma',
  nav_english: 'English',
  nav_portuguese: 'Português',
  nav_german: 'Deutsch',

  // Hero
  hero_title: 'CSSBuy Spreadsheet: Encontre Produtos, Vendedores e Recursos',
  hero_subtitle: 'Encontre e organize informações sobre produtos, vendedores, QC, envio e compras no CSSBuy em um só lugar. Explore nosso CSSBuy Spreadsheet e descubra recursos úteis para pesquisar melhor antes de comprar.',
  hero_cta_primary: 'Explorar o CSSBuy Spreadsheet',
  hero_cta_secondary: 'Visitar o Site Principal',
  hero_trust_1: 'Recursos organizados',
  hero_trust_2: 'Guias atualizados',
  hero_trust_3: 'Pesquisa fácil',
  hero_trust_4: 'Informações de segurança',
  hero_trust_5: 'Conteúdo independente',

  // Categories Dropdown
  categories_title: 'Categorias de Produtos',
  categories_shoes: 'Tênis',
  categories_hoodies: 'Moletom',
  categories_tshirts: 'Camisetas',
  categories_jackets: 'Jaquetas',
  categories_pants: 'Calças',
  categories_headwear: 'Bonés',
  categories_sets: 'Conjuntos',
  categories_underwear: 'Underwear',
  categories_jersey: 'Jersey',
  categories_accessories: 'Acessórios',
  categories_bags: 'Bolsas',
  categories_belts: 'Cintos',
  categories_perfumes: 'Perfumes',
  categories_other: 'Outros',

  // Products Catalog
  products_title: 'Navegar Produtos',
  products_subtitle: 'Navegue pela nossa coleção selecionada de produtos de vendedores confiáveis. Clique em qualquer item para ver detalhes e comprar.',
  products_view_all: 'Ver Todos',

  // Category Buttons
  cat_buttons_title: 'Categorias Populares',
  cat_buttons_subtitle: 'Encontre o que você procura e explore nossa seleção de produtos CSSBuy',

  // How It Works
  how_title: 'Como Funciona',
  how_step1: 'Encontre um produto',
  how_step1_desc: 'Navegue pelas categorias e encontre o item que procura',
  how_step2: 'Compare informações',
  how_step2_desc: 'Compare preços, vendedores e avaliações de qualidade',
  how_step3: 'Pesquise o vendedor',
  how_step3_desc: 'Verifique a reputação e histórico do vendedor',
  how_step4: 'Confira QC',
  how_step4_desc: 'Analise as fotos de Quality Check antes de confirmar',
  how_step5: 'Verifique envio e custos',
  how_step5_desc: 'Calcule o custo total com envio e taxas',
  how_step6: 'Tome sua decisão',
  how_step6_desc: 'Compre com segurança baseado em informações verificadas',

  // Featured Articles
  articles_title: 'Guias e Recursos CSSBuy',
  articles_subtitle: 'Artigos úteis para ajudar você a navegar no mundo CSSBuy',
  articles_read_more: 'Ler Mais',
  articles_seo_title: 'O que é CSSBuy Spreadsheet? Guia Completo 2026',
  articles_seo_desc: 'Descubra como usar o CSSBuy Spreadsheet para encontrar produtos, vendedores confiáveis e economizar nas suas compras. Guia completo para iniciantes.',

  // Comparison
  comparison_title: 'Por que usar CSSBuy Spreadsheet?',
  comparison_header_feature: 'Recurso',
  comparison_header_spreadsheet: 'CSSBuy Spreadsheet',
  comparison_header_manual: 'Pesquisa Manual',
  comparison_org: 'Organização',
  comparison_org_high: 'Alta',
  comparison_org_low: 'Baixa',
  comparison_filters: 'Filtros',
  comparison_yes: 'Sim',
  comparison_no: 'Limitados',
  comparison_compare: 'Comparação',
  comparison_easy: 'Fácil',
  comparison_hard: 'Difícil',
  comparison_seller: 'Pesquisa de vendedores',
  comparison_seller_easy: 'Fácil',
  comparison_seller_slow: 'Demorada',
  comparison_discovery: 'Descoberta de produtos',
  comparison_discovery_high: 'Alta',
  comparison_discovery_med: 'Média',

  // Safety
  safety_title: 'Pesquise com mais informação antes de comprar',
  safety_desc: 'As informações online podem mudar. Preços, estoque, vendedores e custos de envio devem sempre ser verificados antes da compra. Este é um recurso informativo independente.',
  safety_note: 'Sempre verifique informações atualizadas de produtos, vendedores, preços e envio antes de comprar.',

  // FAQ
  faq_title: 'Perguntas Frequentes',
  faq_q1: 'O que é um CSSBuy Spreadsheet?',
  faq_a1: 'O CSSBuy Spreadsheet é uma ferramenta organizada que reúne informações sobre produtos, vendedores, preços e avaliações de qualidade (QC) disponíveis na plataforma CSSBuy. Ele permite que você compare opções e tome decisões mais informadas antes de comprar.',
  faq_q2: 'Como usar o CSSBuy Spreadsheet?',
  faq_a2: 'Você pode usar o CSSBuy Spreadsheet navegando pelas categorias de produtos, filtrando por tipo de item, vendedor ou preço. Cada entrada geralmente contém links para produtos, informações de vendedores e fotos de QC para verificação de qualidade.',
  faq_q3: 'O CSSBuy é legítimo?',
  faq_a3: 'O CSSBuy é uma plataforma de agente de compras conhecida que facilita a compra de produtos da China. Como qualquer plataforma online, é importante verificar vendedores e avaliações antes de fazer compras. Este site é um recurso informativo independente.',
  faq_q4: 'O CSSBuy é seguro?',
  faq_a4: 'A segurança depende de como você usa a plataforma. Sempre pesquise vendedores, verifique fotos de QC, use métodos de pagamento seguros e leia as políticas de reembolso antes de comprar.',
  faq_q5: 'Quanto custa o envio do CSSBuy?',
  faq_a5: 'O custo de envio varia com base no peso, dimensões, destino e método de envio escolhido. Recomendamos usar a calculadora de envio na plataforma CSSBuy para obter estimativas precisas.',
  faq_q6: 'O que são fotos QC?',
  faq_a6: 'Fotos QC (Quality Check) são imagens detalhadas do produto tiradas no armazém antes do envio. Elas permitem que você verifique a qualidade, cor, tamanho e detalhes do item antes de aprovar o envio.',

  // CTA
  cta_title: 'Pronto para explorar o CSSBuy Spreadsheet?',
  cta_button_1: 'Explorar CSSBuy Spreadsheet',
  cta_button_2: 'Visitar Site Principal',

  // Footer
  footer_resources: 'Recursos',
  footer_spreadsheet: 'Spreadsheet',
  footer_guides: 'Guias',
  footer_safety: 'Segurança',
  footer_disclaimer: 'Disclaimer',
  footer_legal: 'Legal',
  footer_privacy: 'Privacidade',
  footer_terms: 'Termos',
  footer_about: 'Sobre',
  footer_languages: 'Idiomas',
  footer_independent: 'Recurso informativo independente. Não afiliado oficialmente ao CSSBuy, salvo indicação explícita.',

  // Article Page
  article_breadcrumb_home: 'Início',
  article_breadcrumb_article: 'Artigo',
  article_related_articles: 'Artigos Relacionados',
  article_back_home: 'Voltar para Início',
  article_last_updated: 'Última atualização',
  article_written_by: 'Escrito por',
  article_author_name: 'CSSBuy Research Team',

  // 404
  notfound_title: 'Página não encontrada',
  notfound_desc: 'A página que você procura não existe ou foi movida.',
  notfound_back: 'Voltar para Início',

  // Meta
  meta_title: 'CSSBuy Spreadsheet – Produtos, Vendedores e Guias CSSBuy',
  meta_description: 'Explore o CSSBuy Spreadsheet com produtos, vendedores, guias de compra, informações de QC, envio, armazém e dicas de segurança. Encontre recursos CSSBuy organizados em um só lugar.',
  meta_keywords: 'CSSBuy, CSSBuy Spreadsheet, produtos CSSBuy, vendedores CSSBuy, guia CSSBuy',
};